<ng-container *ngIf="state$ | async as state">
    <div class="join-cost-center-cost-center-container mat-elevation-z2">
        <div class="join-cost-center-cost-center-table-header">
            <mat-generic-input [fields]="state.selectFields" [(inputFormGroup)]="selectFormGroup"></mat-generic-input>

            <button mat-mini-fab
                    color="primary"
                    [disabled]="state.selectedCostCenter === null"
                    matTooltip="{{ 'app.page.join-cost-center-cost-center.actions.add.label' | translate }}"
                    (click)="onOpenDialog()">
                <mat-icon>add</mat-icon>
            </button>
        </div>
        <mat-progress-bar color="accent" [style.visibility]="state.isLoading ? 'visible' : 'hidden'" mode="indeterminate"></mat-progress-bar>
        <div class="table-container">
            <table mat-table [dataSource]="dataSource" matSort>
                <ng-container matColumnDef="receivingCostCenterName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.join-cost-center-cost-center.receivingCostCenter.label" | translate }}</th>
                    <td mat-cell *matCellDef="let element">
                        {{state.costCenterLookup[element.receivingCostCenterId].name}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="secondaryCostType">
                    <th mat-header-cell *matHeaderCellDef>{{ "app.model.join-cost-center-cost-center.secondaryCostType.label" | translate }}</th>
                    <td mat-cell *matCellDef="let element">
                        {{state.costTypeLookup[element.costTypeId].name}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="placeholder">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element"></td>
                </ng-container>
                <ng-container matColumnDef="validFrom">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.join-cost-center-cost-center.validFrom.label" | translate }}</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.validFrom | date: 'dd.MM.yyyy' }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="validTo">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.join-cost-center-cost-center.validTo.label" | translate }}</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.validTo | date: 'dd.MM.yyyy' }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element" class="actions-column">
                        <button mat-icon-button
                                matTooltip="{{ 'app.page.join-cost-center-cost-center.actions.edit.label' | translate }}"
                                (click)="onOpenDialog(element)">
                            <mat-icon>edit</mat-icon>
                        </button>

                        <button mat-icon-button
                                color="warn"
                                matTooltip="{{ 'app.page.join-cost-center-cost-center.actions.delete.label' | translate }}"
                                (click)="onDeleteApportionment(element)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="state.apportionmentColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: state.apportionmentColumns"></tr>
            </table>
        </div>
        <mat-paginator [pageSize]="20" [pageSizeOptions]="[20, 50]"></mat-paginator>
    </div>
</ng-container>
